import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;
export class OceanElement extends AbstractBlock {
  defineBlock(block: BlockType): void {
    ColorSettings.setEnvironmentColor(block);
    ShapeSettings.setElementShape(block);

    ShapeSettings.setTitleField(block, this.title);

    // VR3フィールドメソッドでは、ラベル名を変えられないので残してる
    const type = 'scale';
    const fieldX = new Blockly.FieldTextInput('10');
    const fieldY = new Blockly.FieldTextInput('10');
    const fieldZ = new Blockly.FieldTextInput('1');

    // 波の設定
    const density = new Blockly.FieldTextInput('50');
    const speed = new Blockly.FieldTextInput('1');

    ShapeSettings.getDummyInput(block)
      .appendField(t.to('幅', 'width') + ':')
      .appendField(fieldX, type + '-x')
      .appendField(t.to('奥行き', 'depth') + ':')
      .appendField(fieldY, type + '-y')
      .appendField(t.to('高さ', 'height') + ':')
      .appendField(fieldZ, type + '-z')
      .appendField(t.to('密度', 'density'))
      .appendField(density, 'density')
      .appendField(t.to('速度', 'speed'))
      .appendField(speed, 'speed');
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const density = CodeSetting.getFieldValue(block, 'density');
    const speed = CodeSetting.getFieldValue(block, 'speed');

    let attribute = CodeSetting.getSubAttributeCode(block);
    attribute += CodeSetting.getVR3FieldValues(block, 'scale');
    // attribute +=  " density = '" + density + "' speed ='" + speed + "' ";
    attribute += CodeSetting.getAttributeCode('density', density);
    attribute += CodeSetting.getAttributeCode('speed', speed);

    const str = CodeSetting.getElementCode(this.name_for_code, attribute, block.id, '');
    return str;
  }
}
